import {
  QuestionnaireTemplateUpdatePage,
  QuestionnaireTemplateVersionCreatePage,
  QuestionnaireTemplateVersionUpdatePage,
} from '@pages';
import { Parent_Type_Enum } from '@risksmart-app/components/generated/graphql';
import i18n from '@risksmart-app/i18n/src/i18n';
import type { RouteObject } from 'react-router';
import OrgFeatureFlaggedRoute from 'src/rbac/OrgFeatureFlaggedRoute';
import { ParamId } from 'src/routes/constants';

export const questionnaireTemplateRoute: RouteObject = {
  path: `:${ParamId.QuestionnaireTemplate}`,
  handle: {
    breadcrumbNode: {
      nodeType: Parent_Type_Enum.QuestionnaireTemplate,
      paramName: ParamId.QuestionnaireTemplate,
    },
  },
  children: [
    {
      index: true,
      element: (
        <OrgFeatureFlaggedRoute featureFlag={'third_party'}>
          <QuestionnaireTemplateUpdatePage activeTabId={'details'} />
        </OrgFeatureFlaggedRoute>
      ),
    },
    {
      path: 'versions',
      handle: {
        title: () => i18n.format(i18n.t('versions'), 'capitalize'),
      },
      children: [
        {
          index: true,
          element: (
            <OrgFeatureFlaggedRoute featureFlag={'third_party'}>
              <QuestionnaireTemplateUpdatePage activeTabId={'versions'} />
            </OrgFeatureFlaggedRoute>
          ),
        },
        {
          path: `update/:${ParamId.QuestionnaireTemplateVersion}`,
          handle: {
            breadcrumbNode: {
              nodeType: Parent_Type_Enum.QuestionnaireTemplateVersion,
              paramName: ParamId.QuestionnaireTemplateVersion,
            },
          },
          children: [
            {
              index: true,
              element: (
                <OrgFeatureFlaggedRoute featureFlag={'third_party'}>
                  <QuestionnaireTemplateVersionUpdatePage
                    activeTabId={'details'}
                  />
                </OrgFeatureFlaggedRoute>
              ),
            },
          ],
        },
        {
          path: 'create',
          handle: {
            title: () => i18n.format(i18n.t('create_version'), 'capitalize'),
          },
          element: (
            <OrgFeatureFlaggedRoute featureFlag={'third_party'}>
              <QuestionnaireTemplateVersionCreatePage />
            </OrgFeatureFlaggedRoute>
          ),
        },
      ],
    },
  ],
};
